module.exports = __webpack_public_path__ + "img/login.69cd0dc9.png";